import { ArcadeCabinetListEntry } from 'arcade/sections/cabinets/list/ArcadeCabinetListEntry';
import React, { Component } from 'react';
import { Grid } from 'shared/grid';
import { Cabinet } from 'shared/interfaces';
import './cabinet-list.less';

interface ArcadeCabinetListProps {
    readonly arcadeId: string;
    readonly getArcadeCabinets: (arcadeId?: string) => Promise<void>;
    readonly loadArcadeCabinetForEditing: (cabinetId: string) => Promise<void>;
    readonly list: Array<Cabinet>;
    readonly deleteArcadeCabinet: (cabinetId: string) => Promise<void>;
}

export default class ArcadeCabinetList extends Component<ArcadeCabinetListProps> {
    componentDidMount(): void {
        this.props.getArcadeCabinets(this.props.arcadeId);
    }

    render() {
        const {
            list
        } = this.props;

        if (!list.length) {
            return <p>No arcade game cabinets.</p>;
        }


        const tiles = list.map((cabinet) => (
            <ArcadeCabinetListEntry
                cabinet={cabinet}
                key={cabinet.cabinetId}
                onDelete={this.props.deleteArcadeCabinet}
                onEdit={this.props.loadArcadeCabinetForEditing}
            />
        ));

        return <Grid className="arcade-cabinets-lists-wrapper">{tiles}</Grid>;
    }
}
